module.exports = __webpack_public_path__ + "img/selected0-min.4ac1f472.png";